
/* ═══════════════════════════════════════════════════════════
   OFHZ Vehicle Selector v3
   改进：
   - 年份只显示有库存的
   - 品牌显示该年可选车型数
   - 选中状态高亮
   - 自动 focus 下一步
   - Clear 按钮按需启用
   ═══════════════════════════════════════════════════════════ */
(function () {
  'use strict';

  var LS_KEY = 'ofhz_selected_vehicle';
  var DATA = null, panel = null, built = false;
  var state = { year: '', make: '', model: '' };
  var yearIndex = null;   // {year: {make: {model: [ranges]}}}

  function titleCase(s) {
    return String(s || '').split(/[-\s]/).map(function (w) {
      return w ? w.charAt(0).toUpperCase() + w.slice(1) : '';
    }).join(' ');
  }
  function getYmm() {
    if (DATA) return DATA;
    if (window.OFHZ_YMM) { DATA = window.OFHZ_YMM; return DATA; }
    return null;
  }

  /* 建立 year -> make -> model 索引 */
  function buildIndex() {
    var data = getYmm();
    if (!data || yearIndex) return;
    yearIndex = {};
    data.forEach(function (item) {
      var mk = item[0];
      item[1].forEach(function (m) {
        var model = m[0], ranges = m[1];
        ranges.forEach(function (r) {
          var mm = String(r[0]).match(/^(\d{4})-(\d{4})$/);
          if (!mm) return;
          var a = +mm[1], b = +mm[2];
          for (var y = a; y <= b; y++) {
            yearIndex[y] = yearIndex[y] || {};
            yearIndex[y][mk] = yearIndex[y][mk] || {};
            yearIndex[y][mk][model] = ranges;
          }
        });
      });
    });
  }

  /* 有库存的年份（降序） */
  function availableYears() {
    buildIndex();
    if (!yearIndex) return [];
    return Object.keys(yearIndex).map(Number).sort(function (a, b) { return b - a; });
  }

  /* 某年有货的品牌 -> {make: 车型数} */
  function makesForYear(y) {
    buildIndex();
    if (!yearIndex || !y) return null;
    var m = yearIndex[y];
    if (!m) return {};
    var out = {};
    Object.keys(m).forEach(function (mk) {
      out[mk] = Object.keys(m[mk]).length;
    });
    return out;
  }

  /* 某年某品牌下的车型 */
  function modelsFor(y, mk) {
    buildIndex();
    if (!yearIndex || !y || !mk) return [];
    var m = yearIndex[y] && yearIndex[y][mk];
    if (!m) return [];
    return Object.keys(m).sort();
  }

  /* ---------- 存储 ---------- */
  function getSaved() {
    try { return JSON.parse(localStorage.getItem(LS_KEY) || 'null'); } catch (e) { return null; }
  }
  function setSaved(v) {
    try { localStorage.setItem(LS_KEY, JSON.stringify(v)); } catch (e) {}
    syncHeader();
  }
  function clearSaved() {
    try { localStorage.removeItem(LS_KEY); } catch (e) {}
    syncHeader();
  }
  function syncHeader() {
    var lbl = document.getElementById('hdr-vehicle-label');
    var btn = document.getElementById('header-vehicle');
    if (!lbl || !btn) return;
    var s = getSaved();
    if (s && s.year && s.make && s.model) {
      lbl.textContent = s.year + ' ' + titleCase(s.make) + ' ' + titleCase(s.model);
      btn.classList.add('has-vehicle');
    } else {
      lbl.textContent = 'Add your vehicle';
      btn.classList.remove('has-vehicle');
    }
  }

  /* ---------- 构建 ---------- */
  function build() {
    if (built) return panel;
    built = true;

    var wrap = document.createElement('div');
    wrap.className = 'ofhz-vp';
    wrap.setAttribute('role', 'dialog');
    wrap.setAttribute('aria-modal', 'true');
    wrap.setAttribute('aria-label', 'Select your vehicle');

    wrap.innerHTML =
      '<div class="ofhz-vp-bg" data-close></div>' +
      '<div class="ofhz-vp-card">' +
        '<div class="ofhz-vp-head">' +
          '<div class="ofhz-vp-head-txt">' +
            '<h3>Find parts for your vehicle</h3>' +
            '<p>Select year, make and model — we only show parts that fit.</p>' +
          '</div>' +
          '<button type="button" class="ofhz-vp-x" data-close aria-label="Close">' +
            '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M18 6L6 18M6 6l12 12"/></svg>' +
          '</button>' +
        '</div>' +

        '<div class="ofhz-vp-tabs">' +
          '<button type="button" class="ofhz-vp-tab is-active" data-tab="ymm">Make / Model</button>' +
          '<button type="button" class="ofhz-vp-tab" data-tab="vin">VIN</button>' +
        '</div>' +

        '<div class="ofhz-vp-pane" data-pane="ymm">' +
          '<div class="ofhz-vp-steps">' +
            '<div class="ofhz-vp-step" data-st="1"><span class="ofhz-vp-num">1</span>Year</div>' +
            '<div class="ofhz-vp-line"></div>' +
            '<div class="ofhz-vp-step" data-st="2"><span class="ofhz-vp-num">2</span>Make</div>' +
            '<div class="ofhz-vp-line"></div>' +
            '<div class="ofhz-vp-step" data-st="3"><span class="ofhz-vp-num">3</span>Model</div>' +
          '</div>' +

          '<div class="ofhz-vp-body">' +
            '<div class="ofhz-vp-col">' +
              '<label class="ofhz-vp-lbl" for="ofhz-vp-year">Year</label>' +
              '<select id="ofhz-vp-year" class="ofhz-vp-sel"><option value="">Select year</option></select>' +
            '</div>' +
            '<div class="ofhz-vp-col">' +
              '<label class="ofhz-vp-lbl" for="ofhz-vp-make">Make</label>' +
              '<select id="ofhz-vp-make" class="ofhz-vp-sel" disabled><option value="">Select year first</option></select>' +
            '</div>' +
            '<div class="ofhz-vp-col">' +
              '<label class="ofhz-vp-lbl" for="ofhz-vp-model">Model</label>' +
              '<select id="ofhz-vp-model" class="ofhz-vp-sel" disabled><option value="">Select make first</option></select>' +
            '</div>' +
          '</div>' +
        '</div>' +

        '<div class="ofhz-vp-pane" data-pane="vin" style="display:none">' +
          '<div class="ofhz-vp-vin">' +
            '<label class="ofhz-vp-lbl" for="ofhz-vp-vin-input">Vehicle Identification Number (VIN)</label>' +
            '<div class="ofhz-vp-vin-row">' +
              '<input type="text" id="ofhz-vp-vin-input" class="ofhz-vp-vin-input" maxlength="17" placeholder="17-character VIN, e.g. 1FTFW1ET5DFC10312" autocomplete="off" spellcheck="false">' +
              '<button type="button" class="ofhz-vp-btn ofhz-vp-btn--primary" id="ofhz-vp-vin-go" disabled>Decode</button>' +
            '</div>' +
            '<p class="ofhz-vp-vin-hint">Find the VIN on your dashboard, driver-side door jamb, or vehicle registration.</p>' +
            '<div id="ofhz-vp-vin-result" class="ofhz-vp-vin-result"></div>' +
          '</div>' +
        '</div>' +

        '<div class="ofhz-vp-foot">' +
          '<span class="ofhz-vp-hint">Not sure? <a href="/pages/contact">Email us your VIN</a></span>' +
          '<div class="ofhz-vp-btns">' +
            '<button type="button" class="ofhz-vp-btn ofhz-vp-btn--ghost" id="ofhz-vp-clear" disabled>Clear</button>' +
            '<button type="button" class="ofhz-vp-btn ofhz-vp-btn--primary" id="ofhz-vp-go" disabled>Apply to browsing</button>' +
          '</div>' +
        '</div>' +
      '</div>';

    document.body.appendChild(wrap);
    panel = wrap;

    wrap.querySelectorAll('[data-close]').forEach(function (n) {
      n.addEventListener('click', close);
    });
    wrap.querySelector('#ofhz-vp-year').addEventListener('change', onYear);
    wrap.querySelector('#ofhz-vp-make').addEventListener('change', onMake);
    wrap.querySelector('#ofhz-vp-model').addEventListener('change', onModel);
    wrap.querySelector('#ofhz-vp-clear').addEventListener('click', onClear);
    wrap.querySelector('#ofhz-vp-go').addEventListener('click', go);

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && panel.classList.contains('is-open')) close();
    });

    initTabs();
    initVin();
    return panel;
  }

  /* ---------- 渲染 ---------- */
  function fillYears() {
    var sel = panel.querySelector('#ofhz-vp-year');
    sel.innerHTML = '';
    var first = document.createElement('option');
    first.value = ''; first.textContent = 'Select year';
    sel.appendChild(first);

    var years = availableYears();
    if (!years.length) {
      first.textContent = 'Loading…';
      return;
    }
    years.forEach(function (y) {
      var o = document.createElement('option');
      o.value = String(y);
      o.textContent = String(y);
      if (String(state.year) === String(y)) o.selected = true;
      sel.appendChild(o);
    });
  }

  function fillMakes() {
    var sel = panel.querySelector('#ofhz-vp-make');
    sel.innerHTML = '';
    var first = document.createElement('option');
    first.value = '';
    sel.appendChild(first);

    if (!state.year) {
      first.textContent = 'Select year first';
      sel.disabled = true;
      return;
    }
    var map = makesForYear(Number(state.year));
    if (!map) { first.textContent = 'Loading…'; sel.disabled = true; return; }

    var makes = Object.keys(map).sort();
    if (!makes.length) {
      first.textContent = 'No makes for that year';
      sel.disabled = true;
      return;
    }
    first.textContent = 'Select make';
    makes.forEach(function (mk) {
      var o = document.createElement('option');
      o.value = mk;
      // 显示该年可用车型数
      o.textContent = titleCase(mk);
      if (state.make === mk) o.selected = true;
      sel.appendChild(o);
    });
    sel.disabled = false;
  }

  function fillModels() {
    var sel = panel.querySelector('#ofhz-vp-model');
    sel.innerHTML = '';
    var first = document.createElement('option');
    first.value = '';
    sel.appendChild(first);

    if (!state.year || !state.make) {
      first.textContent = 'Select make first';
      sel.disabled = true;
      return;
    }
    var models = modelsFor(Number(state.year), state.make);
    if (!models.length) {
      first.textContent = 'No models for that year';
      sel.disabled = true;
      return;
    }
    first.textContent = 'Select model';
    models.forEach(function (md) {
      var o = document.createElement('option');
      o.value = md;
      o.textContent = titleCase(md);
      if (state.model === md) o.selected = true;
      sel.appendChild(o);
    });
    sel.disabled = false;
  }

  function fillSteps() {
    var s1 = !!state.year;
    var s2 = s1 && !!state.make;
    var s3 = s2 && !!state.model;
    setStep(1, s1 ? 'done' : 'active');
    setStep(2, s2 ? 'done' : (s1 ? 'active' : ''));
    setStep(3, s3 ? 'done' : (s2 ? 'active' : ''));
  }
  function setStep(n, cls) {
    var el = panel.querySelector('[data-st="' + n + '"]');
    if (!el) return;
    el.classList.remove('active', 'done');
    if (cls) el.classList.add(cls);
    var num = el.querySelector('.ofhz-vp-num');
    if (num) num.textContent = cls === 'done' ? '✓' : String(n);
  }

  function fillButtons() {
    var go = panel.querySelector('#ofhz-vp-go');
    var clr = panel.querySelector('#ofhz-vp-clear');
    var complete = !!(state.year && state.make && state.model);
    var any = !!(state.year || state.make || state.model || getSaved());

    go.disabled = !complete;
    go.textContent = complete
      ? ('Show parts for ' + state.year + ' ' + titleCase(state.make) + ' ' + titleCase(state.model))
      : 'Apply to browsing';

    if (clr) clr.disabled = !any;
  }

  function render() {
    fillYears();
    fillMakes();
    fillModels();
    fillSteps();
    fillButtons();
  }

  /* ---------- 交互 ---------- */
  function onYear(e) {
    state.year = e.target.value;
    state.make = '';
    state.model = '';
    render();
    // 自动聚焦下一步
    if (state.year) {
      var mk = panel.querySelector('#ofhz-vp-make');
      if (mk && !mk.disabled) { try { mk.focus({preventScroll:true}); } catch(x) {} }
    }
  }
  function onMake(e) {
    state.make = e.target.value;
    state.model = '';
    render();
    if (state.make) {
      var md = panel.querySelector('#ofhz-vp-model');
      if (md && !md.disabled) { try { md.focus({preventScroll:true}); } catch(x) {} }
    }
  }
  function onModel(e) {
    state.model = e.target.value;
    fillSteps();
    fillButtons();
  }
  function onClear() {
    state = { year: '', make: '', model: '' };
    clearSaved();
    render();
    window.dispatchEvent(new CustomEvent('ofhz:vehicle-changed'));
  }

  function go() {
    if (!(state.year && state.make && state.model)) return;
    setSaved({ year: state.year, make: state.make, model: state.model });
    close();
    window.dispatchEvent(new CustomEvent('ofhz:vehicle-changed'));
    if (!document.querySelector('.product-grid')) {
      showToast(state.year + ' ' + titleCase(state.make) + ' ' + titleCase(state.model) +
                ' saved — filtering by fitment');
    }
  }

  function showToast(msg) {
    var t = document.getElementById('ofhz-vp-toast');
    if (!t) {
      t = document.createElement('div');
      t.id = 'ofhz-vp-toast';
      t.className = 'ofhz-vp-toast';
      document.body.appendChild(t);
    }
    t.textContent = msg;
    requestAnimationFrame(function(){ t.classList.add('is-shown'); });
    clearTimeout(t._h);
    t._h = setTimeout(function () {
      t.classList.remove('is-shown');
    }, 3200);
  }

  /* ---------- VIN ---------- */
  function initVin() {
    var input = panel.querySelector('#ofhz-vp-vin-input');
    var btn   = panel.querySelector('#ofhz-vp-vin-go');
    var res   = panel.querySelector('#ofhz-vp-vin-result');
    if (!input || !btn) return;

    input.addEventListener('input', function () {
      var v = input.value.toUpperCase().replace(/[^A-HJ-NPR-Z0-9]/g, '');
      input.value = v;
      btn.disabled = v.length !== 17;
      if (v.length < 17) res.innerHTML = '';
    });

    function decode() {
      var vin = input.value.trim().toUpperCase();
      if (vin.length !== 17) return;
      btn.disabled = true;
      btn.textContent = 'Decoding…';
      res.innerHTML = '';

      fetch('https://vpic.nhtsa.dot.gov/api/vehicles/DecodeVinValues/' +
            encodeURIComponent(vin) + '?format=json')
        .then(function (r) { return r.json(); })
        .then(function (d) {
          var x = (d.Results && d.Results[0]) || {};
          var make  = (x.Make || '').trim();
          var model = (x.Model || '').trim();
          var year  = (x.ModelYear || '').trim();

          if (!make || !model || !year) {
            res.innerHTML = '<div class="ofhz-vp-vin-err">We could not decode that VIN. Double-check it, or use the Make / Model tab.</div>';
            btn.disabled = false; btn.textContent = 'Decode';
            return;
          }

          var mkSlug = make.toLowerCase().replace(/\s+/g, '-');
          if (mkSlug === 'chevy') mkSlug = 'chevrolet';

          var models = modelsFor(Number(year), mkSlug);
          var match = null;
          models.forEach(function (m) {
            var a = m.replace(/[^a-z0-9]/g, '');
            var b = model.toLowerCase().replace(/[^a-z0-9]/g, '');
            if (a === b || a.indexOf(b) === 0 || b.indexOf(a) === 0) match = m;
          });

          /* --- 车型信息表 --- */
          function row(label, val) {
            if (!val) return '';
            return '<div class="ofhz-vp-spec">' +
                     '<span class="ofhz-vp-spec-k">' + label + '</span>' +
                     '<span class="ofhz-vp-spec-v">' + val + '</span>' +
                   '</div>';
          }

          var trim = (x.Trim || '').trim();
          var series = (x.Series || '').trim();

          /* 引擎描述 */
          var engBits = [];
          if (x.DisplacementL) engBits.push(x.DisplacementL + 'L');
          if (x.EngineCylinders) engBits.push(x.EngineCylinders + '-cylinder');
          if (x.EngineHP) engBits.push(x.EngineHP + ' hp');
          var engineStr = engBits.join(' ');

          var drive = (x.DriveType || '').split('/')[0];

          var specs =
            row('Trim', trim || series) +
            row('Engine', engineStr) +
            row('Fuel', x.FuelTypePrimary) +
            row('Drive', drive) +
            row('Body', x.BodyClass) +
            row('Transmission', (x.TransmissionStyle || '') + (x.TransmissionSpeeds ? ' ' + x.TransmissionSpeeds + '-speed' : ''));

          res.innerHTML =
            '<div class="ofhz-vp-vin-found">' +
              '<div class="ofhz-vp-vin-head">' +
                '<div class="ofhz-vp-vin-veh">' + year + ' ' + make + ' ' + model + '</div>' +
                (trim ? '<div class="ofhz-vp-vin-trim">' + trim + '</div>' : '') +
              '</div>' +
              (specs ? '<div class="ofhz-vp-vin-specs">' + specs + '</div>' : '') +
              (match
                ? '<button type="button" class="ofhz-vp-btn ofhz-vp-btn--primary ofhz-vp-vin-use">Use this vehicle</button>'
                : '<div class="ofhz-vp-vin-err ofhz-vp-vin-err--inline">We do not have parts listed for this vehicle yet. <a href="/pages/contact">Ask us</a> and we will check.</div>') +
              '<p class="ofhz-vp-vin-note">Parts are filtered by year, make and model. Engine and trim are shown for reference.</p>' +
            '</div>';

          var useBtn = res.querySelector('.ofhz-vp-vin-use');
          if (useBtn) {
            useBtn.addEventListener('click', function () {
              state.year = year; state.make = mkSlug; state.model = match;
              setSaved({ year: year, make: mkSlug, model: match });
              close();
              window.dispatchEvent(new CustomEvent('ofhz:vehicle-changed'));
              if (!document.querySelector('.product-grid')) {
                showToast(year + ' ' + make + ' ' + model + ' saved — filtering by fitment');
              }
            });
          }
          btn.disabled = false; btn.textContent = 'Decode';
        })
        .catch(function () {
          res.innerHTML = '<div class="ofhz-vp-vin-err">Could not reach the VIN service. Please use the Make / Model tab.</div>';
          btn.disabled = false; btn.textContent = 'Decode';
        });
    }

    btn.addEventListener('click', decode);
    input.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') { e.preventDefault(); decode(); }
    });
  }

  /* ---------- tabs ---------- */
  function initTabs() {
    var tabs = panel.querySelectorAll('.ofhz-vp-tab');
    var panes = panel.querySelectorAll('.ofhz-vp-pane');
    var foot = panel.querySelector('.ofhz-vp-foot');
    tabs.forEach(function (t) {
      t.addEventListener('click', function () {
        var name = t.getAttribute('data-tab');
        tabs.forEach(function (x) { x.classList.toggle('is-active', x === t); });
        panes.forEach(function (p) {
          p.style.display = (p.getAttribute('data-pane') === name) ? '' : 'none';
        });
        if (foot) foot.style.display = (name === 'vin') ? 'none' : '';
        if (name === 'vin') {
          var vi = panel.querySelector('#ofhz-vp-vin-input');
          if (vi) setTimeout(function(){ try{ vi.focus({preventScroll:true}); }catch(e){} }, 60);
        }
      });
    });
  }

  /* ---------- 开关 ---------- */
  function open() {
    build();
    var s = getSaved();
    if (s && s.year && s.make) {
      state.year = String(s.year); state.make = s.make; state.model = s.model || '';
    }
    render();
    panel.classList.add('is-open');
    document.body.style.overflow = 'hidden';

    var tries = 0;
    var t = setInterval(function () {
      if (getYmm() || ++tries > 50) {
        clearInterval(t);
        render();
      }
    }, 100);

    setTimeout(function () {
      var y = panel.querySelector('#ofhz-vp-year');
      if (y) { try { y.focus({preventScroll:true}); } catch (e) {} }
    }, 80);
  }
  function close() {
    if (!panel) return;
    panel.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  function bind() {
    var btn = document.getElementById('header-vehicle');
    if (!btn) return;
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      open();
    });
    syncHeader();
  }

  /* 外部清除时同步 */
  window.addEventListener('ofhz:vehicle-cleared', function () {
    state = { year: '', make: '', model: '' };
    if (panel && panel.classList.contains('is-open')) render();
    syncHeader();
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bind);
  } else {
    bind();
  }
})();
